import { desktopBridge } from './bridge';

/**
 * Whether to install the service worker (offline shell, phone install): only in
 * a production build in a browser. The desktop app loads the same build from
 * 127.0.0.1 and has no need for it, and dev builds would cache stale code.
 */
export function shouldRegisterServiceWorker(env: { prod: boolean; desktop: boolean; supported: boolean }): boolean {
  return env.prod && !env.desktop && env.supported;
}

export function registerServiceWorker(): void {
  const supported = typeof navigator !== 'undefined' && 'serviceWorker' in navigator;
  if (!shouldRegisterServiceWorker({ prod: import.meta.env.PROD, desktop: !!desktopBridge(), supported })) return;
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Without it the app still works; it just won't open offline.
    });
  });
}
